import { render, staticRenderFns } from "./sistemi-di-pagamento.vue?vue&type=template&id=71a90598&"
import script from "./sistemi-di-pagamento.vue?vue&type=script&lang=js&"
export * from "./sistemi-di-pagamento.vue?vue&type=script&lang=js&"
import style0 from "./sistemi-di-pagamento.vue?vue&type=style&index=0&id=71a90598&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports